import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { Short00 } from 'module/ui/components/styles';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { SignalType } from 'api/signal/types';
import { FC } from 'react';
import styled, { css } from 'styled-components';
import { signalTypesAsOptions } from './type-configs';

const Icon = styled.div`
  color: var(--icon-secondary);
`;
const Label = styled.div`
  ${Short00};
`;
const SelectedIndicator = styled(FontAwesomeIcon).attrs({
  size: 12,
})`
  color: var(--blue-60);
`;
const Tile = styled.div<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-02);
  border-radius: var(--border-radius-default);
  height: 80px;
  position: relative;
  cursor: pointer;

  ${({ $selected }) =>
    $selected
      ? css`
          border: 1px solid transparent;
          outline: 2px solid var(--blue-60);
          outline-offset: -2px;
          ${SelectedIndicator} {
            display: block;
            position: absolute;
            top: 10px;
            right: 10px;
          }
        `
      : css`
          border: 1px solid var(--field-border-default);
          ${SelectedIndicator} {
            display: none;
          }
        `};

  ${Icon} {
    flex-shrink: 0;
  }
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
  width: 100%;
  ${Tile} {
    flex: 1;
  }
`;

interface SignalSelectorProps {
  value?: SignalType;
  onChange?: (value: SignalType) => void;
  onHover?: (value?: SignalType) => void;
}

export const SignalTypeSelector: FC<SignalSelectorProps> = ({
  value,
  onChange,
  onHover,
}) => {
  return (
    <Wrapper>
      {signalTypesAsOptions.map((option) => (
        <Tile
          key={option.value}
          $selected={option.value === value}
          onClick={() => onChange?.(option.value)}
          onMouseEnter={() => onHover?.(option.value)}
          onMouseLeave={() => onHover?.(undefined)}
        >
          <Icon>{option.icon}</Icon>
          <Label>{option.label}</Label>
          <SelectedIndicator icon={faCheckCircle} />
        </Tile>
      ))}
    </Wrapper>
  );
};
